import { Component, OnInit,Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
declare var $: any;
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  @Input() message: string;
  @Input() isDisplaypopup: boolean;
  constructor(public dialogRef:MatDialog) { }

  ngOnInit(): void {

    

  }


  onNoClick(): void {
    this.dialogRef.closeAll();
  }
  

}
